import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import CopyBox from '../components/bbcode/copy-box';
import Share from '../components/share/share';

import moment from 'moment';
import { DateTime } from 'luxon';

import DJAreaSideMenu from './sidemenu';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

export default class DJAreaPosters extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			share: false,
			posters: [],
			/*Home: {},
			Clubbers: [],
			Radio: [],
			Schedule: [],
			schedules: 6,

			discord: '/images/socials/discord.png',
			facebook: {},
			website: '/images/socials/website.png',
			facebook_time: 0,*/
		};
		this.fetchPosters = this.fetchPosters.bind(this);
		//this.share = this.share.bind(this);
		//this.showMore = this.showMore.bind(this);
  };

  async componentDidMount() {
		document.title = "Admin Users - Mix365 Radio";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		/*var d = new Date();
		d.setUTCHours(21);
		d.setMinutes(0);
		d.setSeconds(0);
		this.setState({facebook_time: Math.floor(d.getTime()/1000)});*/

		this.fetchPosters();
	}

	componentWillUnmount() {
	}

	async fetchPosters() {
		let params = new URLSearchParams();
		params.append('schedules', this.state.schedules);
		const x = await postApi('/api/v2/djarea/posters', params);
		console.log(x.data);
		this.setState({posters: x.data.Posters});
	}

	/*share(e) {
		this.setState({share: e.toLowerCase()});
	}
	close = (childData) => {
    this.setState({scheduleadd: false, scheduleedit: false, share: false});
	}

	showMore() {
		if( this.state.schedules === 6 ) {
			this.setState({schedules: 100},()=>{this.fetchSocials()});
		} else {
			this.setState({schedules: 6},()=>{this.fetchSocials()});
		}
	}*/
	

	render() {
		//let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

		const posters = 
			Object.keys(this.state.posters).map((e,i) => {
        return (
					<Col key={i} xs={12} md={6} lg={4} className="pb-4">
						<img src={this.state.posters[e].src} width="100%" alt="DJ Poster" />
					</Col>
        )
      })
		return (
			<>
				<Row className="dj-area pt-4 pb-5 px-4">
					<Col xs={12} md={2} className="djarea-sidemenu">
						<DJAreaSideMenu />
					</Col>
					<div className="col-12 col-sm-9 col-lg-10">

						
						<Row>
							<Col>
								<div className="card bg-dark">
									<div className="card-header">
										<h3 className="card-title">Dj Posters</h3>
									</div>
									<div className="card-body">
										<Row>
											{posters}
										</Row>
									</div>
								</div>
							</Col>
						</Row>
					
					</div>
				</Row>
				{this.state.share!==false && <Share url={this.state.share} show={this.state.share.length>0} close={this.close} /> }
			</>
		);
	}
}
